import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { partyLetter } from '../../../partyLetter';
import { StatusTooltip } from '../../../StatusTooltip';
import './PartyTag.scss';

export type PartyTagProps = {
  /** The parties to the contract, as its signature page names them. */
  names: string[];
};

/**
 * The parties to a contract as a "Parties" tag, which keeps the row short;
 * its tooltip says who each one is, as Party A, Party B and so on. Neutral
 * on purpose: it names counterparties, it doesn't report a status.
 */
export const PartyTag: React.FC<PartyTagProps> = ({ names }) => {
  const { t } = useTranslation();

  const labelled = names.map((name, index) => ({
    name,
    label: t('Party {{letter}}', { letter: partyLetter(index) }),
  }));

  return (
    <div className="tree-label-parties">
      <StatusTooltip
        title={
          <dl className="party-tooltip">
            {labelled.map(({ label, name }) => (
              <div key={label} className="party-tooltip__row">
                <dt className="party-tooltip__label">{label}</dt>
                <dd className="party-tooltip__name">{name}</dd>
              </div>
            ))}
          </dl>
        }
        maxWidth={360}
        disableInteractive
      >
        <span className="tree-label-parties__text">{t('Parties')}</span>
      </StatusTooltip>
    </div>
  );
};
